// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root .LightTheme{
  --Background: #F4F3F8;
  --Foreground: #ffffff;
  --TextColor: #212121;
  --AccentColor: #102C97;
  --Invitation: #D7EDFF;
  --Reinitiated: #DAFFF6;
  --Accepted: #DAD4FF;
  --Inprogress: #F8E7AB;
  --Pending: #B2E7FF;
  --Completed: #C0FFC3;
  --Cancelled: #FFBDBD;
  --Stroke: #CCCAD4;
}

.LightTheme, .DarkTheme {
  transition: all 0.3s ease-in-out;
}

:root .DarkTheme{
  --Background: #1F1D2B;
  --Foreground: #252837;
  --TextColor: #E2E2E2;
  --AccentColor: #09A5E0;
  --Invitation: #0053964D;
  --Reinitiated: #00FFC14D;
  --Accepted: #806BFF4D;
  --Inprogress: #FFC8034D;
  --Pending: #0DB2FC4D;
  --Completed: #1EFF274D;
  --Cancelled: #FF43434D;
  --Stroke: #393939;
}

h1, h2, h3, h4, h5, h6, p {
  margin: 0;
  padding: 0;
}

@media (max-width: 1200px) {
  :root {
    font-size: 14px;
  }
}

@media (max-width: 800px) {
  :root {
    font-size: 12px;
  }
}

@media (max-width: 500px) {
  :root {
    font-size: 10px;
  }
}

input:focus,
select:focus,
textarea:focus {
  outline: none;
}

textarea{
  resize: none;
}

*::-webkit-scrollbar {
  width: 6px;
}

*::-webkit-scrollbar-track {
  background-color: #edecec3f;
  border-radius: 10px;
}

*::-webkit-scrollbar-thumb {
  background-color: var(--Stroke);
  border-radius: 10px;
}

*::-webkit-scrollbar-thumb:hover {
  background: var(--Pending);
}

input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear {
    display: none;
}

input[type="password"]::-webkit-contacts-auto-fill-button,
input[type="password"]::-webkit-credentials-auto-fill-button {
    display: none;
}

input[type="password"]::-webkit-contacts-auto-fill-button:focus,
input[type="password"]::-webkit-credentials-auto-fill-button:focus {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB","sourcesContent":[":root .LightTheme{\n  --Background: #F4F3F8;\n  --Foreground: #ffffff;\n  --TextColor: #212121;\n  --AccentColor: #102C97;\n  --Invitation: #D7EDFF;\n  --Reinitiated: #DAFFF6;\n  --Accepted: #DAD4FF;\n  --Inprogress: #F8E7AB;\n  --Pending: #B2E7FF;\n  --Completed: #C0FFC3;\n  --Cancelled: #FFBDBD;\n  --Stroke: #CCCAD4;\n}\n\n.LightTheme, .DarkTheme {\n  transition: all 0.3s ease-in-out;\n}\n\n:root .DarkTheme{\n  --Background: #1F1D2B;\n  --Foreground: #252837;\n  --TextColor: #E2E2E2;\n  --AccentColor: #09A5E0;\n  --Invitation: #0053964D;\n  --Reinitiated: #00FFC14D;\n  --Accepted: #806BFF4D;\n  --Inprogress: #FFC8034D;\n  --Pending: #0DB2FC4D;\n  --Completed: #1EFF274D;\n  --Cancelled: #FF43434D;\n  --Stroke: #393939;\n}\n\nh1, h2, h3, h4, h5, h6, p {\n  margin: 0;\n  padding: 0;\n}\n\n@media (max-width: 1200px) {\n  :root {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 800px) {\n  :root {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 500px) {\n  :root {\n    font-size: 10px;\n  }\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus {\n  outline: none;\n}\n\ntextarea{\n  resize: none;\n}\n\n*::-webkit-scrollbar {\n  width: 6px;\n}\n\n*::-webkit-scrollbar-track {\n  background-color: #edecec3f;\n  border-radius: 10px;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: var(--Stroke);\n  border-radius: 10px;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background: var(--Pending);\n}\n\ninput[type=\"password\"]::-ms-reveal,\ninput[type=\"password\"]::-ms-clear {\n    display: none;\n}\n\ninput[type=\"password\"]::-webkit-contacts-auto-fill-button,\ninput[type=\"password\"]::-webkit-credentials-auto-fill-button {\n    display: none;\n}\n\ninput[type=\"password\"]::-webkit-contacts-auto-fill-button:focus,\ninput[type=\"password\"]::-webkit-credentials-auto-fill-button:focus {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
